"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PercentageBasedOn;
(function (PercentageBasedOn) {
    PercentageBasedOn["LIST_PRICE"] = "list";
    PercentageBasedOn["RETAIL"] = "retail";
})(PercentageBasedOn = exports.PercentageBasedOn || (exports.PercentageBasedOn = {}));
var RatePayee;
(function (RatePayee) {
    RatePayee["BOAT_OWNER"] = "Boat Owner";
    RatePayee["ANCHOR"] = "Anchor";
    RatePayee["CAPTAIN"] = "Captain";
    RatePayee["CREW"] = "Crew";
    RatePayee["SPECIFIC_USER"] = "Specific User";
})(RatePayee = exports.RatePayee || (exports.RatePayee = {}));
